// third-party
import { FormattedMessage } from 'react-intl';
// import EuroIcon from '@mui/icons-material/Euro';
// assets
import {
    KyberNetwork,
    User,
    Building,
    SecurityUser,
    People,
    Briefcase,
    TaskSquare,
    Graph,
    UserTag,
    Award, Airplane, MoneySend, NotificationStatus, ClipboardTick,
    // UserTick
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  applications: KyberNetwork,
  dashboard: People,
  people: People,
  department:Briefcase,
  manager:SecurityUser,
  employee:User,
  admin:SecurityUser,
  hr:Building,
  attendance:TaskSquare,
  report:Graph,
  category:UserTag,
  award:Award,
  holiday:Airplane,
  expenses:MoneySend,
  noticeBoard:NotificationStatus,
//   attendance: UserTick,
//   dashboard:ClipboardTick,
  leaveType:Airplane,
  myAttendance:ClipboardTick
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const humanResource: NavItemType = {
  id: 'group-human-resource',
  title: <FormattedMessage id="hr-human-resource"  />,
  icon: icons.dashboard,
  type: 'collapse',
//   url: '/hr/department',
  permissions:['NL_HR_R'],
  children: [
    // {
    //   id: 'hr-dashboard',
    //   title: <FormattedMessage id="dashboard" />,
    //   type: 'item',
    //   url: '/hr',
    //   icon: icons.applications,
    //   breadcrumbs: false
    // },
   
      {
          id: 'hr-people-department',
          title: <FormattedMessage id="department" />,
          type: 'item',
          url: '/hr/department',
          permissions:['NL_HR_DEPARTMENT_R','NL_HR_DEPARTMENT_C','NL_HR_DEPARTMENT_U','NL_HR_DEPARTMENT_D','NL_HR_DEPARTMENT_L','NL_HR_DEPARTMENT_U_ST'],
          icon: icons.department
      },
     

      {
          id: 'hr-people-employees',
          title: <FormattedMessage id="employees" />,
          type: 'item',
          url: '/hr/employees',
          permissions:['NL_HR_EMPLOYEES_R','NL_HR_EMPLOYEES_C','NL_HR_EMPLOYEES_U','NL_HR_EMPLOYEES_D','NL_HR_EMPLOYEES_L','NL_HR_EMPLOYEES_U_ST'],
          icon: icons.employee
      },
       {
                  id: 'hr-admin-awards',
                  title: <FormattedMessage id="awards" />,
                  type: 'item',
                  url: '/hr/admin/awards',
                  icon: icons.award,
                  permissions:['NL_HR_ADMIN_AWARDS_R','NL_HR_ADMIN_AWARDS_C','NL_HR_ADMIN_AWARDS_U','NL_HR_ADMIN_AWARDS_D','NL_HR_ADMIN_AWARDS_L','NL_HR_ADMIN_AWARDS_U_ST']
              },
            //   {
            //       id: 'hr-admin-expenses',
            //       title: <FormattedMessage id="expenses" />,
            //       type: 'item',
            //       url: '/hr/admin/expenses',
            //       icon: icons.expenses,
            //       permissions:['NL_HR_ADMIN_EXPENSES_R','NL_HR_ADMIN_EXPENSES_C','NL_HR_ADMIN_EXPENSES_U','NL_HR_ADMIN_EXPENSES_D','NL_HR_ADMIN_EXPENSES_L','NL_HR_ADMIN_EXPENSES_U_ST']
            //   },
              {
                  id: 'hr-admin-holidays',
                  title: <FormattedMessage id="leaveCalendar" />,
                  type: 'item',
                  url: '/hr/admin/holidays',
                  permissions:['NL_HR_ADMIN_HOLIDAYS_R','NL_HR_ADMIN_HOLIDAYS_C','NL_HR_ADMIN_HOLIDAYS_U','NL_HR_ADMIN_HOLIDAYS_D','NL_HR_ADMIN_HOLIDAYS_L','NL_HR_ADMIN_HOLIDAYS_U_ST'],
                  icon: icons.holiday
              },
            //   {
            //       id: 'hr-admin-payroll',
            //       title: <FormattedMessage id="payroll" />,
            //       type: 'item',
            //       url: '/hr/admin/payrolls',
            //       permissions:['NL_HR_ADMIN_PAYROLL_R','NL_HR_ADMIN_PAYROLL_C','NL_HR_ADMIN_PAYROLL_U','NL_HR_ADMIN_PAYROLL_D','NL_HR_ADMIN_PAYROLL_L','NL_HR_ADMIN_PAYROLL_U_ST'],
            //       icon: EuroIcon
            //   },
             
              {
                id: 'group-human-resource-attendance',
                title: <FormattedMessage id="attendance"  />,
                icon: icons.attendance,
                type: 'collapse',
                url: '/hr/attendance/attendance',
                permissions:['NL_ATTENDANCE_R'],
              
                children: [
                    {
                        id: 'attendance-my-attendance',
                        title: <FormattedMessage id="attendance" />,
                        type: 'item',
                        url: '/hr/attendance/attendance',
                        icon: icons.myAttendance,
                        permissions:['NL_ATTENDANCE_ATTENDANCE_R','NL_ATTENDANCE_ATTENDANCE_C','NL_ATTENDANCE_ATTENDANCE_U','NL_ATTENDANCE_ATTENDANCE_D','NL_ATTENDANCE_ATTENDANCE_L','NL_ATTENDANCE_ATTENDANCE_U_ST'],
              
                    },
                    {
                        id: 'attendance-leave-type',
                        title: <FormattedMessage id="leave-type" />,
                        type: 'item',
                        url: '/hr/attendance/leave-types',
                        icon: icons.leaveType,
                        permissions:['NL_ATTENDANCE_LEAVE_TYPE_R','NL_ATTENDANCE_LEAVE_TYPE_C','NL_ATTENDANCE_LEAVE_TYPE_U','NL_ATTENDANCE_LEAVE_TYPE_D','NL_ATTENDANCE_LEAVE_TYPE_L','NL_ATTENDANCE_LEAVE_TYPE_U_ST'],
                    },
              
                    {
                        id: 'attendance-leave-application',
                        title: <FormattedMessage id="leave-application" />,
                        type: 'item',
                        url: '/hr/attendance/leave-applications',
                        icon: icons.myAttendance,
                        permissions:['NL_ATTENDANCE_LEAVE_APPLICATION_R','NL_ATTENDANCE_LEAVE_APPLICATION_C','NL_ATTENDANCE_LEAVE_APPLICATION_U','NL_ATTENDANCE_LEAVE_APPLICATION_D','NL_ATTENDANCE_LEAVE_APPLICATION_L','NL_ATTENDANCE_LEAVE_APPLICATION_U_ST']
                    },
                ]
              },
              {
                id: 'hr-admin-notice-board',
                title: <FormattedMessage id="notice-board" />,
                type: 'item',
                url: '/hr/admin/noticeboard',
                permissions:['NL_HR_ADMIN_NOTICE_BOARD_R','NL_HR_ADMIN_NOTICE_BOARD_C','NL_HR_ADMIN_NOTICE_BOARD_U','NL_HR_ADMIN_NOTICE_BOARD_D','NL_HR_ADMIN_NOTICE_BOARD_L','NL_HR_ADMIN_NOTICE_BOARD_U_ST'],
                icon: icons.noticeBoard
            },
    //   {
    //       id: 'hr-admin',
    //       title: <FormattedMessage id="hr-admin" />,
    //       type: 'collapse',
    //       // url: '/hr/admin',
    //       icon: icons.admin,
    //       breadcrumbs: true,
    //       children:[
             
    //       ]
    //   },

  
  ]
};

export default humanResource;


// {
//   id: 'hr-people',
//   title: <FormattedMessage id="people" />,
//   type: 'collapse',
// //   url: '/hr/people',
//   icon: icons.people,
//   children:[
//     { 
//         id: 'hr-people-department',
//         title: <FormattedMessage id="department" />,
//         type: 'item',
//           url: '/hr/people/department',
//         icon: icons.department
//     },
//     { 
//         id: 'hr-people-managers',
//         title: <FormattedMessage id="managers" />,
//         type: 'item',
//           url: '/hr/people/managers',
//         icon: icons.manager
//     },
//     { 
//         id: 'hr-people-employees',
//         title: <FormattedMessage id="employees" />,
//         type: 'item',
//           url: '/hr/people/employees',
//         icon: icons.employee
//     },
//     { 
//         id: 'hr-people-hr',
//         title: <FormattedMessage id="human-resource" />,
//         type: 'item',
//           url: '/hr/people/human-resource',
//         icon: icons.hr
//     },
//     { 
//         id: 'hr-people-attendance',
//         title: <FormattedMessage id="attendance" />,
//         type: 'item',
//           url: '/hr/people/attendance',
//         icon: icons.attendance
//     },
//     { 
//         id: 'hr-people-reports',
//         title: <FormattedMessage id="reports" />,
//         type: 'item',
//           url: '/hr/people/reports',
//         icon: icons.report
//     },
//     { 
//         id: 'hr-people-staff-category',
//         title: <FormattedMessage id="staff-category" />,
//         type: 'item',
//           url: '/hr/people/staff-category',
//         icon: icons.category
//     }
//   ]
// }